<template>
    <button type="button" class="btn btn-tool" title="Xem bản đồ" @click="onClickFunction">
        <i class="far fa-map" style="color: #28a745;"></i>
    </button>
</template>

<script>
import config from '@/config/prod.env';
export default {
    name: "TheOpenMapButton",
    props: {
        onClickParent: {
            type: Function,
            required: true,
        },
        params: {
            type: Object, // Dữ liệu params dạng object
            required: false, // Không bắt buộc
            default: () => ({}),
        },
    },
    methods: {
        async onClickFunction() {
            try {
                const res = await this.onClickParent({ params: this.params }); // Gọi hàm được truyền từ Vuex action
                if (res) {
                    let tableID = res[0].tableId ? res[0].tableId : null
                    let loaiDiadiemId = (res[0].loaiDiadiemId != undefined) ? res[0].loaiDiadiemId.toString() : null
                    let phanloaiDiadiemId = (res[0].phanloaiDiadiemId != undefined) ? res[0].phanloaiDiadiemId.toString() : null
                    if (tableID || loaiDiadiemId || phanloaiDiadiemId) {
                        let link = config.QUYHOACH_PAGE + "AppCongDan/MapTienIch?"
                        link = tableID ? (link + "tableId=" + tableID) : link
                        link = loaiDiadiemId ? link + "&loaiDiadiemId=" + loaiDiadiemId : link
                        link = phanloaiDiadiemId ? link + "&phanloaiDiadiemId=" + phanloaiDiadiemId : link
                        window.open(link, "_blank");
                    }
                }
                else {
                    this.$store.dispatch("alert/error", "Lấy thông tin bản đồ thất bại!", { root: true });
                }
            } catch (error) {
                console.error("Lỗi khi gọi Vuex action:", error);

            }
        },
    },
};
</script>

<style></style>
